module.exports = __webpack_public_path__ + "static/media/icon-ok.d143a1d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-ok.svg
// module id = 191
// module chunks = 0